// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:992px){.buttons-row .btn[data-v-462ee9f7]{display:block;width:100%;margin:0 0 20px 0}}", ""]);
// Exports
module.exports = exports;
